"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _collapse = _interopRequireDefault(require("../../../../../core/collapse"));
var _newSpecial = _interopRequireDefault(require("./new-special"));
var _specialsTable = _interopRequireDefault(require("./specials-table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getInitialState(props) {
  return {
    isOpened: !props.calendarSpecials.length
  };
}
var _ref = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, "Calendar Specials");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "There are no specials for this date yet");
class CalendarSpecials extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getInitialState(this.props));
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("div", null, !this.props.calendarSpecials.length ? _ref2 : /*#__PURE__*/_react.default.createElement(_specialsTable.default, {
      calendarSpecials: this.props.calendarSpecials
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Special' : 'Add Special'), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement(_newSpecial.default, {
      calendarDate: this.props.calendarDate
    }))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}
//
// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CalendarSpecials, "partialQueries", {
  Calendar: _mergeBqlQueries({
    id: true,
    calendarDates: {
      id: true
    },
    calendarSpecials: {
      id: true,
      calendarSpecialNote: true,
      calendarSpecialDescription: true
    }
  }, _specialsTable.default.partialQueries.Calendar)
});
var _default = exports.default = CalendarSpecials;